
import {generateSlider} from '../exports/generateSwiper';
import {finctionalitiesSettings, relatedGamesSettings} from '../exports/swiperSettings';
import Swiper from 'swiper';
export default {
  init() {
    const body = document.querySelector('body')

    if (body.classList.contains('single-instant_game') || body.classList.contains('single-game') || body.classList.contains('single-vlt_game')) {
      /*
      * SELECTORS
      */
      let functionalities = '.functionalities-swiper';
      let  relatedGamesSwiper = '.games-swiper';
      let swipesTabs = document.querySelectorAll('.side .tab');
      let swipesMaxCountFIeld = document.querySelectorAll('.current-slide .total');
      let swipesCurrentCount = document.querySelectorAll('.current-slide .current');
      let swipesMaxCount = swipesTabs.length;
      let videoPlayButtons = document.querySelectorAll('.js-play-video');
      let closeVideoPopButton = document.querySelector('.js-close-pop');
      let popUp = document.querySelector('.single-game-video-pop');
      let popUpIframe = document.querySelector('.single-game-video-pop iframe');
      let slider = new Swiper(functionalities, finctionalitiesSettings);
      const els = {
        $mobileGameLink: document.querySelector('.js-play-video.button.mobile').getAttribute('data-video'),
        $mobileGamePop: document.querySelector('.mobile-game-pop'),
        $mobileGameToggleFullScreen: document.querySelector('.exit-fullscreen-btn-pop'),
        mobileGameModal: document.querySelector('#mobile_game'),
        $singleGameMobileIFrame:  document.querySelector('.iframe-mobile'),
        $singleGameMobileBtn: document.querySelector('.info .exit-fullscreen-btn'),
        $body: document.querySelector('body'),
      }

      const {
        // $mobileGameLink,
        $mobileGameToggleFullScreen,
        // mobileGameModal,
        // $mobileGamePop,
        // $singleGameMobileIFrame,
        $body,
        $singleGameMobileBtn,
      } = els
      /*
       * EVENTS
       */

      const handleToggleMobileGame = () => {
        // $mobileGamePop.classList.toggle('hide');
        $body.classList.toggle('game-full');
        // $body.classList.toggle('visible');
      };

      closeVideoPopButton.addEventListener('click', () => {
        document.querySelector('body').classList.remove('stop-scrolling')
        popUp.classList.remove('open');
        popUpIframe.setAttribute('src','');
      })

      videoPlayButtons.forEach(button => button.addEventListener('click', (el) => {
        let videoLink = el.target.getAttribute('data-video')
        document.querySelector('body').classList.add('stop-scrolling')
        popUp.classList.add('open');
        popUpIframe.setAttribute('src',videoLink);
      }));

      swipesMaxCountFIeld.forEach((e) => {
        e.innerText = swipesMaxCount
      });

      slider.on('slideChange', function(swipe) {
        swipesCurrentCount.forEach((e) => {
          let index = swipe.realIndex + 1
          e.innerText = index
          swipesTabs.forEach((t) => {
            t.classList.remove('current')
            if(Number(index) === Number(t.getAttribute('data-key'))) {
              t.classList.add('current')
            }
          });
        });
      });

      swipesTabs.forEach((tab) => {
        tab.addEventListener('click', (el) => {
          let index = el.target.getAttribute('data-key');
          slider.slideTo(index - 1);
          swipesTabs.forEach((t) => t.classList.remove('current'));
          tab.classList.add('current');
        });
      });
      /*
       * ACTIONS
       */
      handleToggleMobileGame()

      $singleGameMobileBtn.addEventListener('click', () => {
        // mobileGameModal.src = $mobileGameLink;
        // $singleGameMobileIFrame.src = 'about:blank';
        handleToggleMobileGame();
      });

      $mobileGameToggleFullScreen.addEventListener('click', () => {
        // $singleGameMobileIFrame.src = $mobileGameLink;
        // mobileGameModal.src = 'about:blank';
        handleToggleMobileGame();
      });
      relatedGamesSwiper &&  generateSlider(relatedGamesSwiper, relatedGamesSettings);
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singularData.js